export default "__VITE_ASSET__CK7sBHY4__"